import { useNavigate } from 'react-router-dom';
import { Button } from './components/ui/button';

export const UnexpectedErrorPage = ({ resetError }: { resetError: () => void }) => {
  const navigate = useNavigate();
  return (
    <div className={`flex items-center justify-center h-screen flex-col align-middle gap-8`}>
      <div className="flex flex-col gap-3 text-center items-center justify-center">
        <h1 className="leading-10 text-[32px] font-normal text-black">An unexpected error occurred.</h1>
        <p className="leading-[24px] text-base font-normal text-[#71717A]">
          The page you’re looking for might have been moved, deleted, or doesn’t exist yet.
        </p>
      </div>
      <Button
        variant="default"
        className="w-fit h-[48px] cursor-pointer"
        onClick={() => {
          resetError();
          navigate(-1);
        }}
      >
        Go Back
      </Button>
    </div>
  );
};
